import $ from 'jquery';

import home from './single-theme/pages/home';

const $document = $(document);

$document.ready(function() {
    home.init();

    // Call preloader
    $('.preloader').fadeOut();
});
